import React, { useState } from "react";
import "./Contact.scss"
import { useSelector } from "react-redux";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import RegalInputComponents from "../RegalInputComponents/RegalInputComponents";
import RegalTextArea from "../RegalInputComponents/RegalTextArea";
import arrow from "../../assets/arrow.svg"
import MapLocationComponent from "./MapLocationComponent";
import phone from "../../assets/phone.svg"
import mail from "../../assets/mail.svg"
import location from "../../assets/location-line.svg"
import clock from "../../assets/clock.svg"

const Contact = () => {
    const [firstName, setFirstName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [lastName, setLastName] = useState("")
    const [errors, setErrors] = useState({
        firstName: "",
        email: "",
        message: "",
        lastName: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            firstName: "",
            email: "",
            message: "",
            lastName: ""
        }
        const trimmedName = firstName.trim();
        const trimmedEmail = email.trim();
        const trimmedlName = lastName.trim();
        if (trimmedName === "") {
            newErrors.firstName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.firstName = "Please enter a valid name";
            valid = false;
        }

        if (trimmedlName === "") {
            newErrors.lastName = "*Required";
            valid = false;
        } else if (trimmedlName.length < 2 || !nameRegex.test(trimmedlName)) {
            newErrors.lastName = "Please enter a valid name";
            valid = false;
        }

        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }



        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": firstName + " " + lastName,
            "Email": email,
            "PhoneNo": "",
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFirstName("")
                setMessage("")
                setLastName("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    return (
        <div className="Regal-Contact">
            <div className="Regal-Contact-header">
                Contact Us
            </div>
            <div className="Regal-Contact-line" />
            <div className="Regal-Contact-form">
                <div className="Regal-Contact-form-flex">
                    <RegalInputComponents
                        label={"First Name"}
                        placeholder={"enter first name"}
                        onChange={(e) => {
                            setFirstName(e.target.value)
                            handleChange("firstName")

                        }}
                        value={firstName}
                        required
                        error={errors.firstName !== ""}
                        errorText={errors.firstName} />
                    <RegalInputComponents
                        label={"Last Name"}
                        placeholder={"enter last name"}
                        onChange={(e) => {
                            setLastName(e.target.value)
                            handleChange("lastName")

                        }}
                        value={lastName}
                        required
                        error={errors.lastName !== ""}
                        errorText={errors.lastName} />
                </div>
                <RegalInputComponents
                    label={"Email"}
                    placeholder={"enter email"}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    required
                    error={errors.email !== ""}
                    errorText={errors.email} />
                <RegalTextArea
                    label={"Message"}
                    placeholder={"Tell us about your use case..."}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    required
                    error={errors.message !== ""}
                    errorText={errors.message} />
                {showSuccess && < div className="succes-alert">
                    ✔ Thank you for contacting us! We appreciate your message and will be in touch shortly .
                </div>}
                <div className="Regal-Contact-form-btn"
                    onClick={handleContact}
                >
                    Submit
                    {loading ? <div className="loader-btn " /> : <img alt="" src={arrow} />}
                </div>
            </div>
            <div className="Regal-Contact-grid">
                <div className="Regal-Contact-grid-item">
                    <div className="Regal-Contact-grid-item-icon">
                        <img alt="" src={location} />
                    </div>
                    <div className="Regal-Contact-grid-item-cont">
                        <div className="Regal-Contact-grid-item-cont-header">Address</div>
                        <div className="Regal-Contact-grid-item-cont-text">      {companyDetails?.City}, {companyDetails?.PostZipCode},<br /> {companyDetails?.StateProvinceRegion}, {companyDetails?.Country}

                        </div>

                    </div>
                </div>
                <div className="Regal-Contact-grid-item">
                    <div className="Regal-Contact-grid-item-icon">
                        <img alt="" src={phone} />
                    </div>
                    <div className="Regal-Contact-grid-item-cont">
                        <div className="Regal-Contact-grid-item-cont-header">Phone</div>
                        <div className="Regal-Contact-grid-item-cont-text2">      {companyDetails?.Phone}
                        </div>
                    </div>
                </div>
                <div className="Regal-Contact-grid-item">
                    <div className="Regal-Contact-grid-item-icon">
                        <img alt="" src={mail} />
                    </div>
                    <div className="Regal-Contact-grid-item-cont">
                        <div className="Regal-Contact-grid-item-cont-header">Email</div>
                        <div className="Regal-Contact-grid-item-cont-text2">      {companyDetails?.Email}
                        </div>
                    </div>
                </div>
                <div className="Regal-Contact-grid-item">
                    <div className="Regal-Contact-grid-item-icon">
                        <img alt="" src={clock} />
                    </div>
                    <div className="Regal-Contact-grid-item-cont">
                        <div className="Regal-Contact-grid-item-cont-header">Opening Hours</div>
                        <div className="Regal-Contact-grid-item-cont-text3">
                            Monday - Friday
                            <div style={{ color: "#111827" }}>8.00 AM - 9.00 PM</div>

                        </div>
                        <div className="Regal-Contact-grid-item-cont-text3">
                            Saturday - Sunday
                            <div style={{ color: "#111827" }}>8.00 AM - 9.00 PM</div>

                        </div>
                    </div>
                </div>
            </div>
            {companyDetails?.Settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.Latitude}
                lng={companyDetails?.Longitude}
            />}
        </div>
    )
}
export default Contact